/**
 * Connect-time declaration of the progressive board protocol a client renders.
 *
 * The web client advertises the same value as the participant attribute once
 * its stream transport mounts. Declaring it in the session request lets the
 * worker freeze its board tools without waiting for that attribute. Workers
 * treat "0" (and native platforms) as structured boards and keep their bounded
 * attribute negotiation when nothing is declared.
 */
export const WEB_WHITEBOARD_STREAM_CAPABILITY = "2";

/**
 * The client renders tasks published before their teaching review as visible
 * but locked, and applies the later verdict. Advertised as its own attribute.
 */
export const WEB_WHITEBOARD_REVIEW_CAPABILITY = "1";
/** Resolves a failed board over its usable tasks when the worker's `failed` frame says it keeps them. */
export const WEB_WHITEBOARD_KEEP_CAPABILITY = "1";

export type DeclaredWhiteboardStreamCapability = "0" | "1" | "2";

const DECLARED_VALUES: ReadonlySet<string> = new Set(["0", "1", "2"]);

export function parseDeclaredWhiteboardStreamCapability(
  value: unknown
): DeclaredWhiteboardStreamCapability | null {
  return typeof value === "string" && DECLARED_VALUES.has(value)
    ? (value as DeclaredWhiteboardStreamCapability)
    : null;
}
